import React from 'react'

const Newsletter = function newsletter ({text,form,onChange,onSubmit}){
    return (
    <section className="subscribe">
        <div className="container colflex w90">
            <div className="titSub colfex">
                <h3>{text.title}</h3>
                <p>{text.text}</p>
            </div>
            <form className="formSubscribe colflex w90" id="formNewsletter" onSubmit={onSubmit}>
                <input
                    type="hidden"
                    name="token"
                    id="token"
                    value={form.token}
                    onChange={onChange}
                />
                <input 
                    type="email"
                    placeholder="Ingresa tu email aquí"
                    name="mail"
                    value={form.mail}
                    onChange={onChange}
                />
                <button type="submit">
                    <a className="btnFormSubscribe" >Suscribete</a>
                </button>
            </form>
        </div>
    </section>
)
}

export default Newsletter